import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (
  currentPage,
  perPage,
  search,
  searchDateFrom,
  searchDateTo,
) => {
  return await GET(
    `/admin/win_3x/all_bets?page=${currentPage || 1}&per_page=${perPage || 10}&name=${
      search || ""
    }&from=${searchDateFrom || ""}&to=${searchDateTo || ""}`,
  );
};

export const getReport = async (
  startDate,
  endDate,
  currentPage,
  perPage,
  search,
) => {
  return await GET(
    `/admin/win_3x/all_bets/report?start_date=${startDate || ""}&end_date=${endDate || ""}&page=${currentPage || 1}&per_page=${perPage || 10}&name=${encodeURIComponent(search || "")}`,
  );
};
